export const SAVED_ENV_VAR_SET_SELECTION_KEYS = {
  backtest: 'botspot_saved_env_var_set_ids_backtest_v1',
  deployment: 'botspot_saved_env_var_set_ids_deployment_v1',
};

export function loadSavedEnvVarSetSelection(storageKey) {
  if (!storageKey || typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage?.getItem(storageKey);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => typeof id === 'string' && id.trim()).map((id) => id.trim());
  } catch {
    return [];
  }
}

export function saveSavedEnvVarSetSelection(storageKey, ids) {
  if (!storageKey || typeof window === 'undefined') return;
  try {
    const normalized = Array.isArray(ids)
      ? Array.from(new Set(ids.filter((id) => typeof id === 'string' && id.trim()).map((id) => id.trim())))
      : [];
    window.localStorage?.setItem(storageKey, JSON.stringify(normalized));
  } catch {
    // Best-effort browser preference only.
  }
}
